import React, { useEffect, useState } from 'react'
import Post from './Post'
import { db } from "../../firebase"
import CommonHeader from '../../sub-components/CommonHeader';
import Footer from '../../sub-components/Footer';
import SliderHeader from '../../sub-components/SliderHeader';
import MenuCategory from '../../sub-components/MenuCategory';
import ReactPaginate from "react-paginate";
import Pagination from '@mui/material/Pagination';
import AllRestaurantsSideBar from '../../sub-components/AllRestaurantsSideBar';
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';

function Restaurants() {
  const [posts, setPosts] = useState([])
  const [pageNumber, setPageNumber] = useState(0);
  const [input, setInput] = useState("");
  const [posts1, setPosts1] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [inputField, setInputField] = useState('')
  const [errorAddress, setErrorAddress] = useState('')
  const [selectedAddress, setSelectedAddress] = useState('')
  const [homeLat, setHomeLat] = useState('')
  const [homeLng, setHomeLng] = useState('')

  const handleHomeLatLong = (e) =>{
    handleHomeLat(e)
    handleHomeLng(e)
  }
  const handleHomeLat = (e)=>{
    setSelectedAddress(e)
      geocodeByAddress(e)
      .then(results => getLatLng(results[0]))
      .then(latLng => 
          setHomeLat(latLng.lat)          
      )
      .catch(error => console.error('Error', error));        
  }
  const handleHomeLng = (e)=>{
      geocodeByAddress(e)
      .then(results => getLatLng(results[0]))
      .then(latLng => 
          setHomeLng(latLng.lng)      
      )
      .catch(error => console.error('Error', error));        
  }

  const handleAddress = (e)=>{
    setSelectedAddress(e);
  }
  console.log("Home Lat: ", homeLat)
  console.log("Home Lng: ", homeLng)

  
  useEffect(() => {
    db.collection('branches').onSnapshot((snapshot) => {
      setPosts1(snapshot.docs.map((doc) => doc.data()))
    })

    if (posts1 !== undefined) {
      const finalPosts = posts1.filter(res => {
        return res.branch.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
      })

      setFilteredPosts(finalPosts)
    }else {
      return <div>No results3</div>
    }
  }, [searchTerm])

  const updateSearchResults = (e) => {
    setSearchTerm(e.target.value)
    // document.getElementsByClassName('dropdown-content3')[0].style.display = 'auto';
  }

   useEffect(() => {
       db.collection('branches').onSnapshot(snapshot => {
           setPosts(snapshot.docs.map(doc => ({
               id: doc.id,
               post: doc.data(),
           })));
       })
   }, []);
   const menusPerPage = 9;
   const pagesVisited = pageNumber * menusPerPage;

   const displayMenus = <div>

       <section className="section pt-5 pb-5 products-listing">
         <div className="container">
           <div>
         {/* SideBar here */}
             <div className="">
             <div className="col-md-12">
               <h4 className="font-weight-bold mt-0 mb-0"><center>Get All the restaurants near the address you've given</center><small className="h6 mb-0 ml-2">
                 </small>
               </h4>
             </div>
           <hr />
           <form className="explore-outlets-search mb-4 rounded  border">
<GooglePlacesAutocomplete
                style={{width:'100%'}}
                className="pac-container"
   apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
   selectProps={{
   placeholder: 'Search for location address, 5km near your...',
   name:"address",
   inputValue:inputField['address'],
   onInputChange : (e)=>{setInputField({...inputField, ['address']: e})},
   onChange:(place) => {handleHomeLatLong(place.label); setErrorAddress(false);console.log(place)}
   }}
/>

     </form>
             <div className="product-list-view">
   
           <div className="row">
         
                             {
             // hakuna > || iko < 

                              posts.slice(pagesVisited, pagesVisited + menusPerPage).map(({id, post}) => (

                                 <Post
                                 key={id} 
                                 branchImg={post.branchImg}
                                 branchName={post.branch}
                                 restAddress={post.restAddress}
                                 status={post.status}
                                 closingTime={post.closingTime}
                                 openingTime={post.openingTime}
                                 resId={id}
                                 branchAddress={post.branchAddress}
                                 restaurant={post.restaurant}
                                 branchId={id}
                                 selectedAddress={selectedAddress}
                                 homeLat={homeLat}
                                 homeLng={homeLng}
                                 latitude={post.latitude}
                                 longitude={post.longitude}
                                 />
                               ))
               }

               

     </div>
     </div>
   
              
   
             </div>
           </div>
         </div>
       </section>
   
   
   
   
   </div>

 const pageCount = Math.ceil(posts.length / menusPerPage);
 const changePage = ({ selected }) => {
   setPageNumber(selected);
 };


  return (
   <div>
     {displayMenus}
     {/* <center>
       
     <ReactPaginate
        previousLabel={"Previous"}
        nextLabel={"Next"}
        pageCount={pageCount}
        onPageChange={changePage}
        containerClassName={"paginationBttns"}
        previousLinkClassName={"previousBttn"}
        nextLinkClassName={"nextBttn"}
        disabledClassName={"paginationDisabled"}
        activeClassName={"paginationActive"}
      />
     </center> */}

         <Footer />
   </div>
  )
}

export default Restaurants




